module.exports = __webpack_public_path__ + "static/hero-slide2-c18a8fa4d2ad071f0fd0a1ed623679df.mp4";